export default __webpack_public_path__ + "static/media/backgroundV2.1aef8692.jpg";